import {
    AfterViewInit,
    Component,
    ComponentRef,
    EnvironmentInjector,
    InjectionToken,
    Injector,
    Input,
    OnChanges,
    OnDestroy,
    Provider,
    Type,
    ViewContainerRef,
    inject,
} from '@angular/core';

import { DefaultBogLabelComponent } from './default-bog-label.component';

export const BogLabelComponentToken = new InjectionToken<Type<any>>('BogLabelComponentToken');

export function provideBogLabelComponent(cmp: typeof DefaultBogLabelComponent): Provider {
    return {
        provide: BogLabelComponentToken,
        useValue: cmp,
    } as Provider;
}

@Component({
    selector: 'bog-label',
    template: ``,
    standalone: true,
})
export class BogLabelComponent implements OnChanges, AfterViewInit, OnDestroy {
    @Input() bogLabelStyle: boolean;
    @Input() isFromMyBets: boolean;
    @Input() isSettled: boolean;

    private injector = inject(Injector);
    private envInjector = inject(EnvironmentInjector);
    private vcr = inject(ViewContainerRef);
    private cmpToken = inject(BogLabelComponentToken);

    private cmpRef?: ComponentRef<any>;

    ngOnChanges() {
        this.syncInputs();
    }

    ngAfterViewInit() {
        if (!this.cmpToken) {
            throw new Error('Please provide a bog-label component!');
        }

        this.cmpRef = this.vcr.createComponent(this.cmpToken, {
            injector: this.injector,
            environmentInjector: this.envInjector,
        });

        this.syncInputs();
    }

    private syncInputs() {
        if (this.cmpRef) {
            this.cmpRef.setInput('bogLabelStyle', this.bogLabelStyle);
            this.cmpRef.setInput('isFromMyBets', this.isFromMyBets);
            this.cmpRef.setInput('isSettled', this.isSettled);
        }
    }

    ngOnDestroy(): void {
        this.cmpRef && this.cmpRef.destroy();
    }
}
